export default {
    getExpressManage: "/express/queryPageData",//获取快递管理列表
    print: "/express/anewPrint",//重新打印
    exportExcel: "/express/exportExcel",//导出表格
    sendExpress: "/express/sendExpress",//发送快递
    expressTrack: "/express/tracklist",//快递轨迹
    getExpressCompany:"/express/getcomcode/{companyId}",//根据公司id获取可操作的快递公司
    getReceiverInfoList:"/express/getReceiverInfoList",//获取历史常用收件人列表
    getSysDictionary:"/express/getSysDictionary/{type}",//获取快递枚举，3：快递公司，4：发件公司，5：快递类型
    getExpressWhitelist:"/expressWhitelist/getExpressWhitelist",//获取快递白名单列表
    addExpressWhitelist:"/expressWhitelist/addExpressWhitelist",//新增快递白名单
    deleteExpressWhitelist:"/expressWhitelist/delete/{id}",//删除快递白名单
  }
  


// WEBPACK FOOTER //
// ./src/api/config/express.js